import { render, staticRenderFns } from "./v-button.vue?vue&type=template&id=b055bb78&scoped=true"
import script from "./v-button.vue?vue&type=script&lang=js"
export * from "./v-button.vue?vue&type=script&lang=js"
import style0 from "./v-button.vue?vue&type=style&index=0&id=b055bb78&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../com-tool/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b055bb78",
  null
  
)

export default component.exports